import { useContext } from 'react';
import { GlobalMsgCtx } from './GlobalMsgProvider';

const useGlobalMessages = () => {
  const { addGlobalMsg } = useContext(GlobalMsgCtx);
  return { addGlobalMsg };
};

export default useGlobalMessages;
